import jumper from './../core'

const version = '__VERSION__'

const install = Vue => Vue.prototype.$jmp = jumper


const plugin = {
    install,
    version
}

export default plugin

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin)
}
